import React, { useState, useEffect } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//paparse
import { parse } from "papaparse";

//components
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

async function getData(url) {
  const data = parse(await fetchCsv(url), { header: true });
  return data.data;
}

async function fetchCsv(url) {
  const response = await fetch(url);
  const reader = response.body.getReader();
  const result = await reader.read();
  const decoder = new TextDecoder("utf-8");
  const csv = await decoder.decode(result.value);
  return csv;
}

export default function Peru({ survey }) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data
  const [data, setData] = useState([]);

  //useState - questions
  const [questions, setQuestions] = useState([]);

  //useEffect
  useEffect(() => {
    if (survey) handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [survey]);

  //handle get data
  const handleGetData = async () => {
    const csv1 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q1.csv`
    );
    const csv2 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q2.csv`
    );
    const csv3 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q3.csv`
    );
    const csv4 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q4.csv`
    );
    const csv5 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q5.csv`
    );
    const csv6 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q6.csv`
    );
    const csv7 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q7.csv`
    );
    const csv8 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q8.csv`
    );

    const csv9 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q9.csv`
    );
    const csv10 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q10.csv`
    );
    const csv11 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q11.csv`
    );
    const csv12 = await getData(
      `/surveysNational/${language === "en" ? "/en/" : ""}peru_q12.csv`
    );

    let data1 = [
      csv1.map((e) => e["Nivel Nacional"]),
      csv1.map((e) => Number(e["Porcentaje"])),
    ];
    let data2 = [
      csv2.map((e) => e["Nivel Nacional"]),
      csv2.map((e) => Number(e["Porcentaje"])),
    ];

    const y_data3 = csv3.map((e) => e["pregunta"]);
    const x_data3 = Object.keys(csv3[0]).filter((e) => e !== "pregunta");
    let data3 = [
      x_data3,
      y_data3,
      [
        y_data3.map((e, i) => Number(csv3[i][x_data3[0]])),
        y_data3.map((e, i) => Number(csv3[i][x_data3[1]])),
        y_data3.map((e, i) => Number(csv3[i][x_data3[2]])),
        y_data3.map((e, i) => Number(csv3[i][x_data3[3]])),
        y_data3.map((e, i) => Number(csv3[i][x_data3[4]])),
      ],
    ];

    const y_data4 = csv4.map((e) => e["categoria"]);
    const x_data4 = Object.keys(csv4[0]).filter((e) => e !== "categoria");
    let data4 = [
      x_data4,
      y_data4,
      [
        y_data4.map((e, i) => Number(csv4[i][x_data4[0]])),
        y_data4.map((e, i) => Number(csv4[i][x_data4[1]])),
        y_data4.map((e, i) => Number(csv4[i][x_data4[2]])),
      ],
    ];

    let data5 = [
      Object.keys(csv5[0]),
      Object.values(csv5[0]).map((e) => Number(e)),
    ];

    const y_data6 = csv6.map((e) => e["categoria"]);
    const x_data6 = Object.keys(csv6[0]).filter((e) => e !== "categoria");
    let data6 = [
      x_data6,
      y_data6,
      [
        y_data6.map((e, i) => Number(csv6[i][x_data6[0]])),
        y_data6.map((e, i) => Number(csv6[i][x_data6[1]])),
        y_data6.map((e, i) => Number(csv6[i][x_data6[2]])),
        y_data6.map((e, i) => Number(csv6[i][x_data6[3]])),
        y_data6.map((e, i) => Number(csv6[i][x_data6[4]])),
      ],
    ];

    const y_data7 = csv7.map((e) => e["categoria"]);
    const x_data7 = Object.keys(csv7[0]).filter((e) => e !== "categoria");
    let data7 = [
      x_data7,
      y_data7,
      [
        y_data7.map((e, i) => Number(csv7[i][x_data7[0]])),
        y_data7.map((e, i) => Number(csv7[i][x_data7[1]])),
        y_data7.map((e, i) => Number(csv7[i][x_data7[2]])),
      ],
    ];

    const y_data8 = Object.keys(csv8[0]).filter((e) => e !== "Afirmacion");
    const x_data8 = csv8.map((e) => e["Afirmacion"]);
    const series8 = y_data8.map((e, i) => {
      return x_data8.map((el) =>
        Number(csv8.find((e) => e["Afirmacion"] === el)[y_data8[i]])
      );
    });
    const data8 = [y_data8, x_data8, series8];

    // new ones latam pulse
    //q9
    const y_data9 = Object.keys(csv9[0]).filter((e) => e !== "Afirmacion");
    const x_data9 = csv9.map((e) => e["Afirmacion"]);
    const series9 = y_data9.map((e, i) => {
      return x_data9.map((el) =>
        Number(csv9.find((e) => e["Afirmacion"] === el)[y_data9[i]])
      );
    });
    const data9 = [y_data9, x_data9, series9];

    const y_data10 = Object.keys(csv10[0]).filter((e) => e !== "Afirmacion");
    const x_data10 = csv10.map((e) => e["Afirmacion"]);
    const series10 = y_data10.map((e, i) => {
      return x_data10.map((el) =>
        Number(csv10.find((e) => e["Afirmacion"] === el)[y_data10[i]])
      );
    });
    const data10 = [y_data10, x_data10, series10];

    const y_data11 = Object.keys(csv11[0]).filter((e) => e !== "Afirmacion");
    const x_data11 = csv11.map((e) => e["Afirmacion"]);
    const series11 = y_data11.map((e, i) => {
      return x_data11.map((el) =>
        Number(csv11.find((e) => e["Afirmacion"] === el)[y_data11[i]])
      );
    });
    const data11 = [y_data11, x_data11, series11];

    const y_data12 = Object.keys(csv12[0]).filter((e) => e !== "Afirmacion");
    const x_data12 = csv12.map((e) => e["Afirmacion"]);
    const series12 = y_data12.map((e, i) => {
      return x_data12.map((el) =>
        Number(csv12.find((e) => e["Afirmacion"] === el)[y_data12[i]])
      );
    });
    const data12 = [y_data12, x_data12, series12];

    let temp = [
      {
        id: "q1",
        question: TEXT["PER"]["q1"]["question"][language],
        source: TEXT["PER"]["q1"]["source"][language],
        description: TEXT["PER"]["q1"]["description"][language],
        narrative: TEXT["PER"]["q1"]["narrative"][language],
        data: data1,
        graphType: "bar",
        hasOptions: false,
        survey: TEXT["PER"]["q1"]["survey"][language],
        link: TEXT["PER"]["q1"]["link"],
      },
      {
        id: "q2",
        question: TEXT["PER"]["q2"]["question"][language],
        source: TEXT["PER"]["q2"]["source"][language],
        description: TEXT["PER"]["q2"]["description"][language],
        narrative: TEXT["PER"]["q2"]["narrative"][language],
        data: data2,
        graphType: "bar",
        hasOptions: false,
        survey: TEXT["PER"]["q2"]["survey"][language],
        link: TEXT["PER"]["q2"]["link"],
      },
      {
        id: "q3",
        question: TEXT["PER"]["q3"]["question"][language],
        source: TEXT["PER"]["q3"]["source"][language],
        description: TEXT["PER"]["q3"]["description"][language],
        narrative: TEXT["PER"]["q3"]["narrative"][language],
        data: data3,
        graphType: "s_h_bar",
        hasOptions: false,
        isLarge: true,
        survey: TEXT["PER"]["q3"]["survey"][language],
        link: TEXT["PER"]["q3"]["link"],
      },
      {
        id: "q4",
        question: TEXT["PER"]["q4"]["question"][language],
        source: TEXT["PER"]["q4"]["source"][language],
        description: TEXT["PER"]["q4"]["description"][language],
        narrative: TEXT["PER"]["q4"]["narrative"][language],
        data: data4,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q4"]["survey"][language],
        link: TEXT["PER"]["q4"]["link"],
      },
      {
        id: "q5",
        question: TEXT["PER"]["q5"]["question"][language],
        source: TEXT["PER"]["q5"]["source"][language],
        description: TEXT["PER"]["q5"]["description"][language],
        narrative: TEXT["PER"]["q5"]["narrative"][language],
        data: data5,
        graphType: "bar",
        hasOptions: false,
        survey: TEXT["PER"]["q5"]["survey"][language],
        link: TEXT["PER"]["q5"]["link"],
      },
      {
        id: "q6",
        question: TEXT["PER"]["q6"]["question"][language],
        source: TEXT["PER"]["q6"]["source"][language],
        description: TEXT["PER"]["q6"]["description"][language],
        narrative: TEXT["PER"]["q6"]["narrative"][language],
        data: data6,
        graphType: "s_h_bar",
        hasOptions: false,
        isLarge: true,
        survey: TEXT["PER"]["q6"]["survey"][language],
        link: TEXT["PER"]["q6"]["link"],
      },
      {
        id: "q7",
        question: TEXT["PER"]["q7"]["question"][language],
        source: TEXT["PER"]["q7"]["source"][language],
        description: TEXT["PER"]["q7"]["description"][language],
        narrative: TEXT["PER"]["q7"]["narrative"][language],
        data: data7,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q7"]["survey"][language],
        link: TEXT["PER"]["q7"]["link"],
      },
      {
        id: "q8",
        question: TEXT["PER"]["q8"]["question"][language],
        source: TEXT["PER"]["q8"]["source"][language],
        description: TEXT["PER"]["q8"]["description"][language],
        data: data8,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q8"]["survey"][language],
        link: TEXT["PER"]["q8"]["link"],
      },
      {
        id: "q9",
        question: TEXT["PER"]["q9"]["question"][language],
        source: TEXT["PER"]["q9"]["source"][language],
        description: TEXT["PER"]["q9"]["description"][language],

        data: data9,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q9"]["survey"][language],
        link: TEXT["PER"]["q9"]["link"],
      },
      {
        id: "q10",
        question: TEXT["PER"]["q10"]["question"][language],
        source: TEXT["PER"]["q10"]["source"][language],
        description: TEXT["PER"]["q10"]["description"][language],

        data: data10,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q10"]["survey"][language],
        link: TEXT["PER"]["q10"]["link"],
      },
      {
        id: "q11",
        question: TEXT["PER"]["q11"]["question"][language],
        source: TEXT["PER"]["q11"]["source"][language],
        description: TEXT["PER"]["q11"]["description"][language],

        data: data11,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q11"]["survey"][language],
        link: TEXT["PER"]["q11"]["link"],
      },
      {
        id: "q12",
        question: TEXT["PER"]["q12"]["question"][language],
        source: TEXT["PER"]["q12"]["source"][language],
        description: TEXT["PER"]["q12"]["description"][language],

        data: data12,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["PER"]["q12"]["survey"][language],
        link: TEXT["PER"]["q12"]["link"],
      },
    ];
    let tempQ = [];
    temp.forEach((e) => {
      if (e.survey === survey) tempQ.push({ code: e.id, label: e.question });
    });
    setData(temp.filter((el) => el.survey === survey));
    setQuestions(tempQ);
  };

  return (
    <div>
      <SurveyNational data={data} questions={questions} title={survey} />
    </div>
  );
}
